<tr
  (click)="onClick()"
  [class.selected]="ticket === selectedTicket"
>
  <td>
    <div class="all">
      <div class="top-row">
        <input
          class="check"
          type="checkbox"
          [checked]="isSelectedFlag"
          (click)="onSelect($event)"
        />
        <span class="ticket-title">{{ ticket.title }}</span>
        <dependent-choice
          class="sts"
          [topic]="'status'"
          [icon]="'check_circle'"
          [reduced]="TRUE"
          [isTicketContext]="TRUE"
          [showLabel]="TRUE"
          [selectedId]="ticket.statusId"
          [labelOnDemand]="statusLabelerByService"
        ></dependent-choice>
      </div>
      <div class="bottom-row">
        <dependent-choice
          class="dep"
          [topic]="'departments'"
          [icon]="'apartment'"
          [reduced]="TRUE"
          [isTicketContext]="TRUE"
          [showLabel]="TRUE"
          [selectedId]="ticket.departmentId"
          [choiceObserver]="departmentIdObserver"
          [labelOnDemand]="departmentLabelerByService"
        ></dependent-choice>
        <dependent-choice
          class="dc"
          [topic]="'branches'"
          [icon]="'domain'"
          [reduced]="TRUE"
          [isTicketContext]="TRUE"
          [showLabel]="TRUE"
          [selectedId]="ticket.branchId"
          [labelOnDemand]="branchLabelerByService"
        ></dependent-choice>
        <div class="space">
          <span class="ticket-date">{{ dateFormatted(ticket) }}</span>
          <dependent-choice
            class="prio"
            [topic]="'priority'"
            [icon]="'error_circle'"
            [reduced]="TRUE"
            [isTicketContext]="TRUE"
            [showLabel]="FALSE"
            [selectedId]="ticket.priorityId"
            [labelOnDemand]="priorityLabelerByService"
          ></dependent-choice>
        </div>
      </div>
    </div>
  </td>
</tr>
